import React, {createContext, useEffect, useState} from "react";

import UnitsService from "./units/unitsStore";
import FieldsService from "./fields/fieldsStore";

export const Service = createContext({
  unitsMeta: {},
  fieldsMeta: {}
})

let IncludeService = (props: any) => {
  
  let [lastUpdateUnits, setLastUpdateUnits] = useState({})
  let [lastUpdateFields, setLastUpdateFields] = useState({})
  
  useEffect(() => {
    UnitsService.subscribe(setLastUpdateUnits)
    FieldsService.subscribe(setLastUpdateFields)
  }, [])
  
  let listService: any = {
    unitUpdate: lastUpdateUnits,
    fieldUpdate: lastUpdateFields
  }
  
  return (
    <>
      <Service.Provider value={listService}>
        {props.children}
      </Service.Provider>
    </>
  )
}

export default IncludeService